<template>
    <v-col
        :cols="cols"
        class="py-0 px-2">
        <slot></slot>
    </v-col>
</template>

<script>
export default {
    name: 'FilterFormCell',
    props: {
        cols: {
            type: String,
            required: true,
        },
    },
};
</script>
